import React from 'react';

function Footer() {
  return (
    <footer className="container py-5">
      <div className="row">
       
        <div className="col-6 col-md">
          <h5>Telefone</h5>
          <ul className="list-unstyled text-small">
            <li><a className="text-muted text-decoration-none" target='_blank' rel="noopener noreferrer" href="https://wa.me/555186553680/?text=ola"><i className="bi bi-whatsapp"></i> 51 8655-3680</a></li>
            
          </ul>
        </div>
        <div className="col-8 col-md">
          <h5>Email</h5>
          <ul className="list-unstyled text-small">
            <li><a className="text-muted text-decoration-none" href="mailto:contato@institutopasqualin.com.br">contato@institutopasqualin.com.br</a></li>
            
          </ul>
        </div>
        <div className="col-6 col-md">
          <h5>Redes</h5>
          <ul className="list-unstyled text-small">
            <li><a className="text-muted text-decoration-none" target='_blank' rel="noopener noreferrer" href="https://www.instagram.com/instituto_pasqualin/"><i className="bi bi-instagram"></i> @instituto_pasqualin</a></li>

          </ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
